import {SearchAlertUserConstant} from "../redux_constants/search.user.constant";
import {urlEncoder} from "../redux_actions/users.action";
import {UserActions} from '../redux_constants/users.constant';

export const getNewState = () => {
    return {
        isFetching: true,
        search: '',
        page: 1,
        numPages: 1,
        total: 1,
        groups: {},
        organisations: [],
    }
}

const InitialState = getNewState();

export const searchUserReducer = (state = InitialState, action) => {
    var returnableState = {}
    switch (action.type) {
        case SearchAlertUserConstant.USER_SEARCH_INITIATED:
            return {
                ...state,
                isFetching: true,
            }
        case SearchAlertUserConstant.USER_SEARCH_SUCCESS:
            return {
                ...state,
                isFetching: false,
            }
        case SearchAlertUserConstant.USER_SEARCH_FAILED:
            return {
                ...state,
                err: action.error,
                isFetching: false,
            }
        case SearchAlertUserConstant.USER_UPDATE_URL_STATE:
            returnableState = {...state, ...action.urlState};
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertUserConstant.USER_UPDATE_SEARCHES:
            returnableState = {
                ...state,
            }
            returnableState.searches = action.searches;
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertUserConstant.USER_CHANGE_PAGE:
            return {
                ...state,
                page: action.page
            }
        case UserActions.CHANGE_TOTAL_NUMBER_OF_PAGES_USER:
            return {
                ...state,
                numPages: action.numPages
            }
        case UserActions.CHANGE_TOTAL_USER:
            return {
                ...state,
                total: action.total
            }
        case UserActions.UPDATE_GROUPS:
            var updatedInfo = {}
            for (var i = 0; i < action.groups.length; i++) {
                let group = action.groups[i]
                updatedInfo[group.id] = group;
            }
            return {
                ...state,
                groups: updatedInfo
            }
        case UserActions.ADD_ORGANISATIONS:
            return {
                ...state,
                organisations: action.organisations
            }
        case UserActions.UPDATE_ORGANISATIONS:
            return {
                ...state,
                organisations: [...state.organisations, ...action.organisations]
            }
        case UserActions.DELETE_ORGANISATION:
            return {
                ...state,
                organisations: state.organisations.filter(org => org.name !== action.organisationName)
            };
        case SearchAlertUserConstant.UPDATE_SEARCHTERM:
            return {
                ...state,
                search: action.search
            }
        case UserActions.ADD_GROUPS:
            const new_groups = state.groups;
            action.groups?.forEach(group => {
                new_groups[group.id] = group;
            })
            return {
                ...state,
                groups: new_groups
            }
        default :
            returnableState = state
            return returnableState;
    }
}

export const updateUrl = (state) => {
    var encodedUrl = urlEncoder(state);
    window.history.replaceState(state, 'filter_params', encodedUrl);
}